import { render } from "./AssociationActivity.vue?vue&type=template&id=b8bd8f6a"
import script from "./AssociationActivity.vue?vue&type=script&lang=js"
export * from "./AssociationActivity.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__